import { Routing } from "@common/_constants/";
import {
    getUserFromStorage,
    removeUserFromStorage,
    TelemetryService,
} from "@common/_services";
import * as HttpStatus from "http-status-codes";

export function refetch(
    url,
    options: RequestInit = { method: "GET" },
    withAuth = true,
    redirectOnError = true
): Promise<any> {
    if (!options.method) options.method = "GET";
    if (!options.headers) options.headers = {};

    if (withAuth) {
        const user = getUserFromStorage();

        if (!user) {
            window.location.href = Routing.Client.Account.SIGN_OUT;
            return Promise.resolve();
        }

        // tslint:disable-next-line:no-string-literal
        options.headers["Authorization"] = "Bearer " + user.token;
    }

    return fetch(url, options).then(response => {
        TelemetryService.trackDependency(
            null,
            options.method,
            url,
            null,
            response.status === HttpStatus.OK,
            response.status
        );

        if (redirectOnError) {
            if (response.status === HttpStatus.UNAUTHORIZED) {
                removeUserFromStorage();

                window.location.href = Routing.Client.Account.SIGN_IN_SESSION_EXPIRED;
                return null;
            }

            if (response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
                window.location.href = "/pro/error";
                return null;
            }
        }

        return response;
    });
}
